import { getCalendarEvents } from '@wwe-portal/web/services/client/calendar';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { QUERY_KEY_CALENDAR } from '../../utils/constants/keys';
import {
  getCurrentPSTDateEnd,
  getCurrentPSTDateStart,
} from '@wwe-portal/utils/date';
import {
  isWithinADayEvent,
  isTomorrowEvent,
  compareEvent,
} from '@wwe-portal/web/utils/calendar/helper';

const aDayInMilliseconds = 24 * 60 * 60 * 1000;
export const useGetCalendarEvents = () => {
  return useQuery({
    queryKey: [QUERY_KEY_CALENDAR],
    queryFn: async () => {
      const currentDate = getCurrentPSTDateStart().getTime();
      const response = await getCalendarEvents({
        startDateFrom: currentDate - aDayInMilliseconds * 30,
        startDateTo: currentDate + aDayInMilliseconds * 21,
        endDateFrom: currentDate,
        endDateTo: currentDate + aDayInMilliseconds * 60,
      });

      return response.data;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export const useGetTodayEvents = () => {
  const { data, isLoading } = useGetCalendarEvents();
  const { startPSTDate, endPSTDate } = useMemo(() => {
    return {
      startPSTDate: getCurrentPSTDateStart().getTime(),
      endPSTDate: getCurrentPSTDateEnd().getTime(),
    };
  }, []);

  const todayEvents = useMemo(() => {
    return data?.data
      .filter((event) => {
        return isWithinADayEvent(event, { startPSTDate });
      })
      .sort(compareEvent);
  }, [startPSTDate, endPSTDate, data]);

  return {
    todayEvents,
    isLoading,
  };
};

export const useGetTomorrowEvents = () => {
  const { data, isLoading } = useGetCalendarEvents();
  const { startPSTDate } = useMemo(() => {
    const startPSTDate = getCurrentPSTDateStart().getTime();

    return {
      startPSTDate,
    };
  }, []);

  const tomorrowEvents = useMemo(() => {
    return data?.data
      .filter((event) => {
        return isTomorrowEvent(event, { startPSTDate });
      })
      .sort(compareEvent);
  }, [startPSTDate, data]);

  return {
    tomorrowEvents,
    isLoading,
  };
};
